import './styles/home.css'
import { initReveal } from './reveal'
import { initNav } from './nav'
import { initAnalytics } from './analytics'
import { initHub } from './hub'
import { initVoicePlayers } from './voice-player'

// Stamped so a deployed build is identifiable from the DOM: <html data-env="dev">.
document.documentElement.dataset['env'] = import.meta.env.VITE_ENV_NAME

initAnalytics()
initNav()
initReveal()
initHub()
initVoicePlayers()
